import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { CostCenter } from 'src/app/models/cost-center.model';
import { CostCentersFormComponent } from '../cost-centers-form/cost-centers-form.component';
import { CostCentersImportFormComponent } from '../cost-centers-import-form/cost-centers-import-form.component';

@Component({
  selector: 'app-cost-centers-component',
  templateUrl: './cost-centers.component.html'
})
export class CostCentersComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public gridData: CostCenter[] = [];
  public gridView: any[] = [];
  public filter: CompositeFilterDescriptor | undefined;
  public mySelection: string[] = [];
  public getCentrosDeCustoDescontinuados: boolean = false
  public customMsgService: CustomMessagesService;

  constructor(public msgService: MessageService, private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.allData = this.allData.bind(this);
  }

  public ngOnInit(): void {
    this.load();
  }

  // Update Grid collection during changing My Team/All Team
  public onTeamChange(pageSize: number): void {
    pageSize === 25
      ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
      : (this.gridView = this.gridData.slice(0, pageSize));
  }

  public onFilter(inputValue: string): void {
    this.gridView = process(this.gridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: this.getField,
            operator: 'contains',
            value: inputValue
          }
        ]
      }
    }).data;

    this.dataBinding ? this.dataBinding.skip = 0 : null;
  }

  public getField = (args: CostCenter) => {
    return `${args.codigo}_${args.nome}`;
  }

  public open(): void {

    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('centroDeCusto'),
      // Show component
      content: CostCentersFormComponent
    });

    dialogRef.result.subscribe((result) => {
      this.load();
    });
  }

  public openEdit(c: CostCenter): void {

    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('centroDeCusto'),
      // Show component
      content: CostCentersFormComponent
    });

    const userInfo = dialogRef.content.instance as CostCentersFormComponent;
    userInfo.formValue = c;
    userInfo.setFormValues();

    dialogRef.result.subscribe((result) => {
      this.load();
    });
  }

  canList() {
    return User.canCentroCustosList();
  }

  canCreate() {
    return User.canCentroCustosCreate();
  }

  canDelete() {
    return User.canCentroCustosDelete();
  }

  canEdit() {
    return User.canCentroCustosEdit();
  }

  public upload() {

    const dialogRef: DialogRef = this.dialogService.open({

      title: this.customMsgService.translate('importarCentrosDeCusto'),
      // Show component
      content: CostCentersImportFormComponent
    });

    dialogRef.result.subscribe((result) => {
      this.gridView = this.gridData;
      this.load();
    });
  }

  public delete(e: CostCenter): void {
    var sim = this.customMsgService.translate('yes');
    var nao = this.customMsgService.translate('no');
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate('confirmacao'),
      content: this.customMsgService.translate('desejaRemover'),
      actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
      } else if (result.text == sim) {
        this.api.cruddelete<BaseHttpResult>('CentroDeCusto', e.id).
          then(res => {
            if (res.ok) {
              this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('registoApagadoComSucesso'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
              });
              this.load();
            } else {
              this.notificationService.show({
                appendTo: this.container,
                content: res.message,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
              });
            }
          }).
          catch(err => {
          });
      }
    });
  }

  load() {
    this.gridView = this.gridData;
    this.api
      .getRequest<BaseHttpResponse<CostCenter[]>>("CentroDeCusto/GetCentrosDeCusto?getCentrosDeCustoDescontinuados=" + this.getCentrosDeCustoDescontinuados)
      .then((data) => {
        this.gridData = data.value;
        this.gridView = this.gridData;
      })
      .catch((err) => { });
  }

  public checkValue() {
    this.load();
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.gridView, { filter: this.filter }).data,
    };
    return result;
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.gridData = filterBy(this.gridView, filter);
  }
}

